import { PaperclipIcon } from "@storytell/bsky-icons";
import type { Component } from "solid-js";
import { Portal } from "solid-js/web";

/**
 * Full-screen dropzone overlay that appears when files are dragged over the page
 */
export const FullScreenDropzone: Component = () => {
  return (
    <Portal mount={document.body}>
      <div
        class="fixed inset-0 pointer-events-none z-50"
        style={{
          background: "rgba(0, 0, 0, 0.6)",
          "backdrop-filter": "blur(4px)",
        }}
      >
        <div class="absolute inset-0 flex items-center justify-center">
          <div
            class="w-full max-w-2xl mx-auto p-12 border-4 border-dashed rounded-3xl"
            style={{
              "border-color": "rgba(var(--color-primary-rgb, 99, 102, 241), 0.5)",
              background: "linear-gradient(135deg, rgba(0,0,0,0.3), rgba(0,0,0,0.1))",
              "box-shadow": `
              inset 0 6px 20px rgba(0,0,0,0.4),
              inset 0 3px 12px rgba(0,0,0,0.3),
              0 0 60px rgba(var(--color-primary-rgb, 99, 102, 241), 0.2)
            `,
            }}
          >
            <div class="text-center">
              <div
                class="inline-flex items-center justify-center w-20 h-20 rounded-full mb-4"
                style={{
                  background: "linear-gradient(135deg, rgba(0,0,0,0.3), rgba(0,0,0,0.1))",
                  "box-shadow": "inset 0 2px 8px rgba(0,0,0,0.4), inset 0 1px 4px rgba(0,0,0,0.3)",
                }}
              >
                <PaperclipIcon class="w-10 h-10 text-primary/80" />
              </div>
              <p class="text-2xl font-medium text-white/90 mb-2">Drop files here</p>
              <p class="text-sm text-white/60">Upload your files to add them to the conversation</p>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};
